var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('help')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }